import React, { useContext } from 'react';
import * as Sentry from '@sentry/browser';
import { LangContext } from '../src/providers/LangProvider';
import Layout from '~/components/layout/_layout';
import SEO from '~/components/seo';
import { Trans, withI18n } from '@lingui/react';
import { YellowButton, BlackTransparentButton } from '~/styles/buttons';
import styled from 'styled-components';
import getConfig from 'next/config';

const { publicRuntimeConfig: {APP_VERSION} } = getConfig();

function ErrorPage() {
    const ctxLang = useContext(LangContext);

    Sentry.setExtra('language', ctxLang.state.lang);
    Sentry.setExtra('app_version', APP_VERSION);
    Sentry.captureMessage('404 - Not Found', {
        level: 'warning',
    });

    return (
        <Layout>
            <SEO title="Trisbee" description="Trisbee" />
            <ContentWrapper>
                <Heading>
                    <Trans id="global.eror.heading" />
                </Heading>
                <Description>
                    <Trans id="global.eror.description" />
                </Description>
                <CustomYellowButton onClick={() => location.reload()}>
                    <Trans id="global.eror.cta" />
                </CustomYellowButton>
            </ContentWrapper>
        </Layout>
    );
}

export default ErrorPage;

const ContentWrapper = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding-top: 86px;
    padding-bottom: 160px;
`;

const Heading = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 94px;
    line-height: 100px;
    letter-spacing: -1px;
    color: #0cc8a8;
    text-align: center;
`;

const Description = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 44px;
    line-height: 70px;

    color: #000000;
    text-align: center;
`;

const CustomYellowButton = styled(YellowButton)`
    margin: 0 auto;
    margin-top: 16px;
`;
